import { CalendarDate } from '@internationalized/date'

export function isOverInterval(prevTimestamp: string | null, intervalMs: number): boolean {
  if (!prevTimestamp) return true
  const prev = parseInt(prevTimestamp, 10)
  if (isNaN(prev)) return true

  return Date.now() - prev > intervalMs
}

export function getCurrentTimestamp(): string {
  return Date.now().toString()
}

export function debounce<F extends (...args: unknown[]) => void>(func: F, ms: number): F {
  let timeoutId: ReturnType<typeof setTimeout> | null = null

  return function (...args: Parameters<F>) {
    if (timeoutId) {
      clearTimeout(timeoutId)
    }

    timeoutId = setTimeout(() => {
      func(...args)
    }, ms)
  } as F
}

export type DateOrTimestamp = Date | number | undefined

export function normalizeToDate(v?: DateOrTimestamp): CalendarDate | undefined {
  if (!v) return undefined

  const date = typeof v === 'number' ? new Date(v) : v

  return !date
    ? undefined
    : new CalendarDate(date.getFullYear(), date.getMonth() + 1, date.getDate())
}
